import React from 'react';

interface JobDescriptionInputProps {
  jobDescription: string;
  onJobDescriptionChange: (text: string) => void;
}

const JobDescriptionInput: React.FC<JobDescriptionInputProps> = ({ 
  jobDescription, 
  onJobDescriptionChange 
}) => {
  return (
    <div>
      <h2>💼 Job Description</h2>
      <div className="form-group">
        <label className="form-label">
          Paste the job description here:
        </label>
        <textarea
          className="form-control textarea"
          value={jobDescription}
          onChange={(e) => onJobDescriptionChange(e.target.value)}
          placeholder="Enter the job description here..."
        />
      </div>
      <div className="alert alert-info">
        <strong>💡 Tip:</strong> Include the full job posting with requirements, 
        responsibilities, and qualifications for best results.
      </div>
    </div>
  );
};

export default JobDescriptionInput;
